import { makeAutoObservable } from "mobx";
import { INotificationStore } from "./Notification.types";
import { IRootStore } from "../index";

class Notification implements INotificationStore {
  rootStore: IRootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  notification = {};

  removeNotification = () => {
    this.notification = {};
  };

  setNotification = ({ message, type }) => {
    this.notification = { show: true, message, type };
  };
}

export default Notification;
